import { render, staticRenderFns } from "./FakeTop.vue?vue&type=template&id=fd045f0a&scoped=true&"
import script from "./FakeTop.vue?vue&type=script&lang=js&"
export * from "./FakeTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd045f0a",
  null
  
)

export default component.exports